import React from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { Grid, Spinner } from '@geist-ui/react'
import {
  TopBar,
  NoTransactionCode,
  InvalidState,
  UnenrolledAccount,
  AuthRedirect,
} from 'components'
import Success from '../pages/success'
import YTSignup from '../pages/yt/signup'
import YTSuccess from '../pages/yt/success'
import FBSignup from '../pages/fb/signup'
import FBSuccess from '../pages/fb/success'
import NDSignup from '../pages/nd/signup'
import NDSuccess from '../pages/nd/success'
import TTDSignup from '../pages/ttd/signup'
import TTDSuccess from '../pages/ttd/success'
import AccountSetup from '../accounts/Layout'
import ErrorBoundary from './ErrorBoundary'
import { parseSessionStorage } from '../accounts/Signup/components/SignupComplete/utils'

export default function Container({ children }) {
  const { isAuthenticated, isLoading, error } = useAuth0()

  if (isLoading) {
    return (
      <div
        style={{
          width: '100vw',
          height: '100vh',
          overflow: 'hidden',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spinner />
      </div>
    )
  }

  if (error) {
    return (
      <div
        style={{
          width: '100vw',
          height: '100vh',
          overflow: 'hidden',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {error.message === 'no_transaction_code' && <NoTransactionCode />}
        {error.error_description ===
          "Cannot read property 'transaction_code' of undefined" && (
          <NoTransactionCode />
        )}
        {error.message === 'account_not_enrolled' && <UnenrolledAccount />}
        {error.message === 'Invalid state' && <InvalidState />}
      </div>
    )
  }

  if (!isAuthenticated) {
    const urlPath = window.location.pathname

    // This map of page routes include trailing slashes and no trailing
    // slashes to catch both potential versions with fewer errors
    const landingPages = {
      // Handles redirects to login pages if needed
      '/auth': <AuthRedirect />,
      '/auth/': <AuthRedirect />,

      // Routes to the standard signup success page
      '/success': <Success />,
      '/success/': <Success />,

      '/enroll': <AccountSetup />,
      '/enroll/': <AccountSetup />,

      // Marketing landing pages that handle routing to
      // ad-specific versions of the signup and success pages
      // YOUTUBE
      '/yt/signup': <YTSignup />,
      '/yt/signup/': <YTSignup />,
      '/yt/success': <YTSuccess />,
      '/yt/success/': <YTSuccess />,
      // FACEBOOK
      '/fb/signup': <FBSignup />,
      '/fb/signup/': <FBSignup />,
      '/fb/success': <FBSuccess />,
      '/fb/success/': <FBSuccess />,
      // NEXTDOOR
      '/nd/signup': <NDSignup />,
      '/nd/signup/': <NDSignup />,
      '/nd/success': <NDSuccess />,
      '/nd/success/': <NDSuccess />,
      // TTD
      '/ttd/signup': <TTDSignup />,
      '/ttd/signup/': <TTDSignup />,
      '/ttd/success': <TTDSuccess />,
      '/ttd/success/': <TTDSuccess />,
    }

    return (
      <ErrorBoundary>{landingPages[urlPath] || <AccountSetup />}</ErrorBoundary>
    )
  }

  // If the user is authenticated and has a pending enrollment completion, show the account setup page
  if (isAuthenticated) {
    const pendingEnrollmentCompletion = parseSessionStorage('pendingLinkTuple')
    if (pendingEnrollmentCompletion) {
      return (
        <ErrorBoundary>
          <AccountSetup />
        </ErrorBoundary>
      )
    }
  }

  return (
    <Grid.Container
      direction="column"
      justify="center"
      alignItems="center"
      height="100%"
      style={{ paddingTop: '2rem' }}
    >
      <TopBar />
      <ErrorBoundary>
        <Grid.Container justify="center" alignItems="center" height="100%">
          <main>{children}</main>
        </Grid.Container>
      </ErrorBoundary>
    </Grid.Container>
  )
}
